/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
import { VisionApplication } from '../../application';
import { FolderDTO } from '../../service/folder';

export class VisionGroupList {
    toolbar: dhtmlXToolbarObject;
    grid!: dhtmlXGridObject | null;
    selectedGroup: string;

    folderCache?: Map<string, FolderDTO>;

    callback: ((n: string) => void) | null;

    constructor(toolbar: dhtmlXToolbarObject, grid: dhtmlXGridObject | null, name: string, callback: ((n: string) => void) | null) {
        this.toolbar = toolbar;
        this.grid = grid;
        this.callback = callback;
        this.selectedGroup = '';

        this.toolbar.addButtonSelect(name, 1, 'Groupings', [], '', '', false, false, 0, '');

        this.folderCache = VisionApplication.getInstance().assetFolderService.folderCache;
        this.folderCache?.forEach((folder) => {
            this.toolbar.addListOption(name, folder.id, 1, 'button', folder.name, '');
            this.toolbar.clearListOptionImage(name, folder.id);
        });

        this.toolbar.attachEvent('onClick', (itemId) => {
            console.log('Clicked On: ' + itemId);
            if (this.folderCache?.has(itemId)) {
                this.selectedGroup = itemId;
                if (this.grid != null) {
                    this.filterGrid();
                }
                if (this.callback != null) {
                    this.callback(itemId);
                }
            }
        });
    }

    public filterGrid() {
        const folder = this.folderCache?.get(this.selectedGroup);
        this.grid?.forEachRow((rowId) => {
            this.grid?.setRowHidden(rowId, true);
            this.grid?.setUserData(rowId, 'hidden', true);
            if (folder?.items.some((e) => e.id === rowId)) {
                this.grid?.setRowHidden(rowId, false);
                this.grid?.setUserData(rowId, 'hidden', false);
            }
        });
    }

    public filter(folder: string | null): void {
        if (folder != null) {
            this.selectedGroup = folder;
            this.filterGrid();
        } else {
            const firstEntry = this.folderCache?.entries().next().value;
            if (firstEntry) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const [fkey, _fvalue] = firstEntry;
                this.selectedGroup = fkey;
                this.filterGrid();
            }
        }
    }
}
